module.exports = __webpack_public_path__ + "img/rule-icon.5a17b0f2.svg";